import React, {useEffect, useState} from "react";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import useAxiosPrivateFileUpload from "../../../../hooks/useAxiosPrivateFileUpload";
import {toastError, toastSuccess} from "../../../../helpers/Toast";

const LABELS = {
  STUDENT_ID: "Legitymacja ucznia/studenta",
  BANK_ACCOUNT_CONSENT: "Zgoda na rachunek osoby trzeciej",
  OTHER: "Inny dokument"
};

const EmployeeSelfDocumentsCard = () => {
  const axiosPrivate = useAxiosPrivate();
  const axiosPrivateFileUpload = useAxiosPrivateFileUpload();
  const [documents, setDocuments] = useState([]);
  const [type, setType] = useState("STUDENT_ID");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const response = await axiosPrivate.get("/employee-self-documents");
      setDocuments(response.data || []);
    } catch (error) {
      toastError(error.response?.data?.message || "Nie udało się pobrać dokumentów");
    }
  };

  useEffect(() => {
    load();
  }, []);

  const upload = async () => {
    if (!file) {
      toastError("Wybierz plik PDF, JPG lub PNG");
      return;
    }
    const formData = new FormData();
    formData.append("type", type);
    formData.append("file", file);
    setLoading(true);
    try {
      await axiosPrivateFileUpload.post("/employee-self-documents", formData);
      setFile(null);
      const input = document.getElementById("employee-self-document-file");
      if (input) input.value = "";
      await load();
      toastSuccess("Dokument został przesłany");
    } catch (error) {
      toastError(error.response?.data?.message || "Nie udało się przesłać dokumentu");
    } finally {
      setLoading(false);
    }
  };

  const download = async item => {
    try {
      const response = await axiosPrivate.get(`/employee-self-documents/${item.id}/download`, {responseType: "blob"});
      const url = URL.createObjectURL(response.data);
      const link = window.document.createElement("a");
      link.href = url;
      link.download = item.fileName || "dokument";
      window.document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      toastError("Nie udało się pobrać dokumentu");
    }
  };

  const remove = async id => {
    try {
      await axiosPrivate.delete(`/employee-self-documents/${id}`);
      await load();
      toastSuccess("Dokument został usunięty");
    } catch (error) {
      toastError(error.response?.data?.message || "Nie udało się usunąć dokumentu");
    }
  };

  return (
    <div className="card mt-4">
      <div className="card-header fw-bold">Moje dokumenty</div>
      <div className="card-body">
        <div className="row g-2 align-items-end mb-3">
          <div className="col-md-3">
            <label className="form-label">Rodzaj dokumentu</label>
            <select className="form-select" value={type} onChange={event => setType(event.target.value)}>
              <option value="STUDENT_ID">Legitymacja ucznia/studenta</option>
              <option value="BANK_ACCOUNT_CONSENT">Zgoda na rachunek osoby trzeciej</option>
              <option value="OTHER">Inny dokument</option>
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">Plik</label>
            <input id="employee-self-document-file" className="form-control" type="file" accept="application/pdf,image/jpeg,image/png" onChange={event => setFile(event.target.files?.[0] || null)}/>
          </div>
          <div className="col-md-3">
            <button type="button" className="btn btn-primary w-100" disabled={loading} onClick={upload}>Prześlij dokument</button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-sm align-middle mb-0">
            <thead><tr><th>Rodzaj</th><th>Plik</th><th>Dodano</th><th></th></tr></thead>
            <tbody>
            {documents.map(item => (
              <tr key={item.id}>
                <td>{LABELS[item.type] || item.type}</td>
                <td>{item.fileName}</td>
                <td>{item.uploadedAt ? new Date(item.uploadedAt).toLocaleString("pl-PL") : ""}</td>
                <td className="text-end">
                  <button type="button" className="btn btn-sm btn-outline-primary me-2" onClick={() => download(item)}>Pobierz</button>
                  <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => remove(item.id)}>Usuń</button>
                </td>
              </tr>
            ))}
            {documents.length === 0 && <tr><td colSpan="4">Brak przesłanych dokumentów.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSelfDocumentsCard;
